
































































































































import { Filters } from '@shared/interfaces/config';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import TextEditor from '@shared/components/forms/inputs/text-editor/text-editor.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import { ValidationObserver } from 'vee-validate';
import {
  SendMessageUsingTemplateFormModel,
  SendMessageUsingTemplateModel,
} from '@tools/interfaces/template';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';

@Component({
  name: 'bpc-send-message-using-template-drawer',
  components: {
    'bpc-drawer-modal': DrawerModal,
    'bpc-select': Select,
    'bpc-entity-select': EntitySelect,
    'bpc-text-editor': TextEditor,
    'bpc-input': Input,
    'bpc-switch': Switch,
    ValidationObserver,
    'bpc-multi-select': MultiSelect,
  },
})
export default class SendMessageUsingTemplateDrawer extends Vue {
  declare $refs: {
    templateSelector: InstanceType<typeof EntitySelect> & {
      getEntities(): void;
    };
  };
  // PROPS
  @Prop({ type: String, required: true }) readonly entityName: string;
  @Prop({ type: String, default: 'send-message-using-template-drawer' }) readonly drawerId: string;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showDrawer: boolean;
  @Prop({ type: Boolean, default: false }) readonly withErrors: boolean;
  @Prop({ type: String, default: 'admin' }) readonly availabilityContext: string;
  @Prop({ type: Boolean, default: true }) readonly hideSendingType: boolean;
  @Prop({ type: String, default: 'personalized' }) readonly defaultSendingType: string;
  @Prop({ type: String, default: 'message' }) readonly defaultMessageType: string;
  @Prop({ type: Number }) readonly defaultTemplateId: number;
  // @Prop({
  //   type: Array,
  //   default() {
  //     return [];
  //   },
  // })
  // readonly contactIds: number[];
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly errors: Record<string, string[]>;
  @Prop({
    type: Array,
    default() {
      return {};
    },
  })
  readonly contactIds: number[];
  @Prop({
    type: Array,
    default() {
      return {};
    },
  })
  readonly selectedItemIds: number[];

  // DATA
  public contactIdsToSend = [];

  formModel: SendMessageUsingTemplateFormModel = {
    template: null,
    // contact_ids: [],
    body: null,
    title: null,
    sending_type: null,
    type: 'message',
    // send_mail: true,
    // from_system: true,
  };
  showDrawerIndex = null;
  personalizedSendingType: boolean = false;
  errorByField = {
    entity_name: null,
    title: null,
    body: null,
    sending_type: null,
    type: null,
    // send_mail: null,
    // from_system: null,
  };

  public labelInputAttributes = {
    for: 'global__',
  };

  // COMPUTED
  get drawerTitle() {
    return this.$t('global.modals.send_message_using_template.title', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }

  get drawerBody() {
    return this.$t('global.modals.send_message_using_template.body', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }

  get messageTypeOptions() {
    const options = [
      {
        text: 'global.messages.other_type.label',
        value: 'message',
      },
    ];

    if (this.entityName === 'booking' || this.entityName === 'booking-event') {
      options.push({
        text: 'global.messages.booking_reminder_type.label',
        value: 'booking_reminder',
      });
    }

    if (this.entityName === 'subscription' || this.entityName === 'enrollment') {
      options.push(
        {
          text: 'global.messages.payment_request_type.label',
          value: 'payment_request',
        },
        {
          text: 'global.messages.payment_reminder_type.label',
          value: 'payment_reminder',
        },
      );
    }

    return options;
  }

  get templateSelectorFilters(): Filters {
    return [
      {
        filterField: 'entity',
        value: this.entityName.replaceAll('-', '_'),
      },
      {
        filterField: 'available_in',
        value: this.availabilityContext,
      },
      {
        filterField: 'type',
        value: 'email',
      },
      {
        filterField: 'message_type',
        value: this.formModel.type,
      },
    ];
  }

  get selectedTemplateId(): number {
    return this.formModel?.template?.id || null;
  }

  // LIFECYCLE
  created() {
    this.formModel.type = this.defaultMessageType || 'message';
    if (this.defaultTemplateId) {
      this.loadDefaultTemplate();
    }
  }
  mounted() {
    this.showDrawerIndex = Date.now();
    this.contactIdsToSend = this.contactIds;
    this.formModel.sending_type = this.defaultSendingType;
    this.personalizedSendingType = this.defaultSendingType === 'personalized';
  }

  // METHODS
  closeDrawer() {
    this.showDrawerIndex = Date.now();
    this.cleanErrorByField();
    this.$emit('close-drawer');
  }

  onSendMessage() {
    this.$emit('send-message-clicked', this.mapModel(this.formModel));
  }

  mapModel(model: SendMessageUsingTemplateFormModel): SendMessageUsingTemplateModel {
    let contactIdsToSendArray = this.selectedItemIds;
    if (this.entityName === 'contact') {
      contactIdsToSendArray = this.contactIdsToSend.map(item => {
        return item.id;
      });
    }

    return {
      entity_name: this.entityName,
      entity_ids: contactIdsToSendArray,
      body: model.body,
      title: model.title,
      sending_type: model.sending_type,
      type: model.type,
      // send_mail: model.send_mail,
      // from_system: model.from_system,
    };
  }

  cleanModel() {
    this.formModel = {
      template: null,
      // contact_ids: [],
      body: null,
      title: null,
      sending_type: this.defaultSendingType,
      type: 'message',
      // send_mail: true,
      // from_system: true,
    };
    this.personalizedSendingType = this.defaultSendingType === 'personalized';
  }

  setTitleWithTemplateSelectedContent() {
    this.formModel.title = this.formModel?.template?.name || '';
  }

  setBodyWithTemplateSelectedContent() {
    this.formModel.body = this.formModel?.template?.content || '';
  }

  modelFieldChange(field) {
    // this.$emit('model-change', field, this.formModel);
    this.errorByField[field] = null;
    if (field === 'sending_type') {
      this.onChangeSelectedSendingType(this.personalizedSendingType);
    }
  }

  setErrorByField() {
    this.errorByField = Object.keys(this.errors).reduce((res, key) => {
      res[key] = this.errors[key][0] || null;
      return res;
    }, this.errorByField);
  }

  cleanErrorByField() {
    this.errorByField = {
      entity_name: null,
      title: null,
      body: null,
      sending_type: null,
      type: null,
      // send_mail: null,
      // from_system: null,
    };
  }

  onChangeSelectedSendingType(val) {
    if (!val) {
      this.$set(this.formModel, 'template', null);
      this.$set(this.formModel, 'body', null);
      this.$set(this.formModel, 'sending_type', 'grouped');
    } else {
      this.$set(this.formModel, 'sending_type', 'personalized');
    }
  }

  setMessageType() {
    this.formModel.type = this.formModel?.template?.message_type || 'message';
  }

  async loadDefaultTemplate() {
    if (this.defaultTemplateId) {
      const url = `${this.$bpcApiRouteHelper.getEntityPath('template')}/${this.defaultTemplateId}`;
      try {
        const res = await this.$bpcApi.get(url, {}).toPromise();
        if (res.data) {
          this.formModel.template = res.data;
        }
        // eslint-disable-next-line no-empty
      } catch (error) {}
    }
  }

  onChangeMessageType() {
    this.$nextTick().then(() => {
      this.formModel.template = null;
      this.setTitleWithTemplateSelectedContent();
      this.setBodyWithTemplateSelectedContent();
      this.$refs.templateSelector?.getEntities();
    });
  }

  // WATCHERS
  @Watch('selectedTemplateId')
  onSelectedTemplateIdChange(val) {
    if (val) {
      this.setTitleWithTemplateSelectedContent();
      this.setBodyWithTemplateSelectedContent();
    }
    this.setMessageType();
  }
  @Watch('errors', { deep: true })
  onErrorsChange(val) {
    this.cleanErrorByField();
    this.setErrorByField();
  }
  @Watch('showDrawer')
  onShowDrawerChange(val) {
    this.cleanModel();
  }
  @Watch('contactIds', { deep: true })
  onContacIdsPropChange(val) {
    this.contactIdsToSend = this.contactIds;
  }
}
